<template>
  <modal-wrapper
    @onCancelClick="$bvModal.hide('calcResults')"
    modalId="calcResults"
    hide-footer
    dialogClass="result-modal"
    title="Результаты расчетов"
    scrollable
  >
    <div v-if="project.result && project.result.social" class="result-block">
      <subtitle variant="v2">Индивидуальный пожарный риск в зданиях и на территории объекта</subtitle>

      <div class="result-table">
        <div class="result-table-head-item" :key="title" v-for="title in socialHeaderItems">{{ title }}</div>

        <template v-for="(social, index) in project.result.social">
          <div class="result-table-item" :key="index">{{ social.name }}</div>
          <div class="result-table-item" :key="index + 1" :style="'background: ' + social.color" />
          <div
            class="result-table-item"
            :key="index + 6"
            v-html="toNormal(social.base_risk)"
            :style="{ background: social.base_risk > legalIndRisk ? '#FF1E1E' : '#0DB56F' }"
          />
          <div class="result-table-item" :key="index + 2">{{ social.dot_name }}</div>
          <div
            class="result-table-item"
            :key="index + 3"
            v-if="social.probability"
            v-html="toNormal(social.probability)"
          />
          <div class="result-table-item" :key="index + 4" v-else>0.00</div>
          <div
            class="result-table-item"
            :key="index + 5"
            v-if="social.risk"
            v-html="toNormal(social.prod_risk)"
            :style="{ background: social.prod_risk > legalIndRisk ? '#FF1E1E' : '#0DB56F' }"
          />
          <div class="result-table-item" :key="index + 7" v-else style="background: '#0DB56F'">0.00</div>
          <div
            class="result-table-item"
            :key="index + 8"
            v-if="social.risk"
            v-html="toNormal(social.risk)"
            :style="{ background: social.risk > legalIndRisk ? '#FF1E1E' : '#0DB56F' }"
          />
          <div
            class="result-table-item"
            :key="index + 9"
            v-else
            v-html="toNormal(social.base_risk)"
            :style="{ background: social.base_risk > legalIndRisk ? '#FF1E1E' : '#0DB56F' }"
          />
          <div class="result-table-item" :key="index + 10" v-html="toNormal(social.base_risk)" />
        </template>
      </div>
    </div>

    <div v-if="project.result && project.result.residential" class="result-block">
      <subtitle variant="v2">Индивидуальный и социальный пожарный риск на прилегающей территории объекта</subtitle>

      <div class="result-table seven-columns">
        <div class="result-table-head-item" :key="index" v-for="(title, index) in residentialHeaderItems">
          {{ title }}
        </div>

        <template v-for="(residential, index) in project.result.residential">
          <div :key="index + 1" class="result-table-item">
            {{ residential.name }}
          </div>
          <div :key="index + 2" class="result-table-item">{{ residential.dot_name }}</div>
          <div :key="index + 3" class="result-table-item">{{ residential.count_of_persons }}</div>
          <div
            :key="index + 4"
            class="result-table-item"
            :style="{ background: residential.ind_risk > legalResIndRisk ? '#FF1E1E' : '#0DB56F' }"
            v-html="toNormal(residential.ind_risk)"
          />
          <div :key="index + 5" class="result-table-item" v-html="toNormal(legalResIndRisk)" />
          <div
            :key="index + 6"
            class="result-table-item"
            v-html="toNormal(residential.risk)"
            :style="{ background: residential.risk > legalResSocRisk ? '#FF1E1E' : '#0DB56F' }"
          />
          <div :key="index + 7" class="result-table-item" v-html="toNormal(legalResSocRisk)" />
        </template>
      </div>
    </div>
    <div v-if="project.status == 4" class="license-info-block">
      <main-text class="license-info-text">
        Данный отчет содержит только структуру расчета и его результаты. Для отображения порядка расчета необходимо
        <a class="license-info-link" target="_blank" href="https://mst.su/firerisks/buy/"> купить лицензию</a
        >.</main-text
      >
      <main-text>
        Пример отчета можно скачать по ссылке:
        <a class="license-info-link" href="https://firerisks.ru/report.pdf" target="_blanc"
          >https://firerisks.ru/report.pdf</a
        ></main-text
      >
    </div>

    <div class="report-files">
      <subtitle v-if="project.status == 4" variant="v2">Файл отчета</subtitle>
      <subtitle v-else variant="v2">Файлы отчетов</subtitle>

      <div class="download-buttons">
        <a class="download-button" :href="project.file">
          <img src="../../files/download-file-icon.svg" alt="download icon" />
          Отчет.doc
        </a>

        <button class="download-button" v-if="$auth.user().isAdmin" @click="downloadPdf(project.id)">
          <img src="../../files/download-file-icon.svg" alt="download icon" />
          Отчет.pdf
        </button>

        <button class="download-button" v-if="$auth.user().isAdmin" @click="downloadTocDocx(project.id)">
          <img src="../../files/download-file-icon.svg" alt="download icon" />
          Отчет ТОС.pdf
        </button>
      </div>
    </div>

    <div v-if="project.status == 4" class="contacts-block">
      <main-text class="contacts-block-title">
        Вы можете приобрести лицензию в отделе продаж или на нашем
        <a class="license-info-link" href="https://mst.su/firerisks/buy/" target="_blank">сайте</a>
      </main-text>

      <div class="contacts-block-items">
        <div class="contacts-block-item">
          <main-text class="contacts-block-item-title">Телефон</main-text>
          <a class="license-info-link" href="tel: 88007758351">8 800 775-83-51</a>
        </div>

        <div class="contacts-block-item">
          <main-text class="contacts-block-item-title">Время работы</main-text>
          <main-text>9:00 - 18:00 (МСК)</main-text>
        </div>
      </div>
    </div>

    <div class="form-button-block">
      <main-button v-if="project.status == 4" color="secondary-fill" class="form-button" @click="buyLicense">
        Купить лицензию
      </main-button>

      <main-button
        v-if="project.status == 4"
        color="link"
        class="form-button"
        @click="$router.push({ path: '/', query: { nolicense: true } })"
      >
        Активировать лицензию
      </main-button>

      <main-button @click="$bvModal.hide('calcResults')" color="link">Закрыть</main-button>
    </div>
  </modal-wrapper>
</template>

<script>
import MainButton from "../ui/MainButton.vue";
import Subtitle from "../ui/Subtitle.vue";
import MainText from "../ui/Text.vue";
import ModalWrapper from "./ModalWrapper.vue";
export default {
  components: {
    ModalWrapper,
    Subtitle,
    MainButton,
    MainText,
  },
  props: {
    project: Object,
    legalResSocRisk: Number,
    legalIndRisk: Number,
    legalResIndRisk: Number,
    toNormal: Function,
  },
  data() {
    return {
      socialHeaderItems: [
        "Должность",
        "Цвет",
        "Риск в зданиях",
        "Точка",
        "Вероятность",
        "Значение риска в точке",
        "Итоговое значение риска",
        "Норм. значение",
      ],
      residentialHeaderItems: [
        "Название",
        "Точка",
        "Кол-во человек",
        "Инд. риск",
        "Норм. значение",
        "Соц. риск",
        "Норм. значение",
      ],
    };
  },
  methods: {
    downloadPdf(id) {
      this.$http({
        url: "risk/get-pdf-version?proj_id=" + id,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Доумент " + id + ".pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
    },

    buyLicense() {
      window.open("https://mst.su/firerisks/buy/", "_blank");
    },

    downloadTocDocx(id) {
      this.$http({
        url: "risk/get-toc-version?proj_id=" + id,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Доумент " + id + ".docx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
    },
  },
};
</script>

<style scoped>
.result-block {
  padding: 0 24px;
  margin-bottom: 32px;
  min-width: 1000px;
}
.result-table {
  display: grid;
  grid-template-columns: 1fr repeat(7, minmax(auto, max-content));
  margin-top: 16px;
}
.result-table-head-item {
  position: relative;
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0px 8px 0px 16px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  color: #585874;
  background: var(--background-color);
  border-bottom: 1px solid var(--border-color);
}
.result-table-head-item::after {
  position: absolute;
  right: 0;
  top: 9px;
  content: "";
  height: 24px;
  width: 1px;
  background: var(--grey-color);
}

.result-table-item {
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0px 8px 0px 16px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--black-color);
}
.seven-columns {
  grid-template-columns: 1fr repeat(6, minmax(auto, max-content));
}

.report-files {
  margin: 32px 0;
  padding: 0 24px;
  width: 524px;
}

.download-buttons {
  display: flex;
  gap: 48px;
  margin-top: 16px;
}
.download-button {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--black-color);
  padding: 0;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 8px;
}
.license-info-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  margin: 32px;
  background: rgba(207, 17, 36, 0.15);
}
.license-info-text {
  max-width: 477px;
  color: var(--error-color);
  margin-bottom: 16px;
}
.license-info-link {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--primary-color);
}
.license-info-link:hover {
  color: var(--primary-hover-color);
}
.contacts-block {
  margin: 32px;
}
.contacts-block-items {
  display: flex;
  gap: 48px;
}
.contacts-block-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.contacts-block-title {
  margin-bottom: 16px;
}
.contacts-block-item-title {
  color: var(--grey-3-color);
}
</style>
